// noop, not supported on web
export const openURL = (url) => { };
//# sourceMappingURL=linking.web.js.map